import TabReducer from "../TabReducer"
const combinedReducers ={
    TabReducer:TabReducer,

}


export default combinedReducers;